import React, { ChangeEvent, CompositionEvent } from "react";

// 以下は .jsx のため TS から見た型宣言ファイルが無いので個別に抑制する
// （プロジェクト全体で .tsx 化が進むまでの暫定対応）。
// @ts-ignore
import GuideImage from "../../../components/guide-image/GuideImage";
// @ts-ignore
import TitleBlock from "../../../components/block/TitleBlock";
import Input from "../../../components/form-item/Input";

interface ProjectEndClientInputProps {
  value: string;
  onChange: (value: string) => void;
}

/**
 * プロジェクト作成ウィザード用のエンドクライアント入力。
 * 編集用 ProjectEndClient は projectId 必須で PATCH オートセーブする実装のため、
 * 作成フローでは projectId なしで親 state にのみ反映する軽量版を使う。任意項目。
 */
const ProjectEndClientInput: React.FC<ProjectEndClientInputProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  // IME 確定時、ブラウザ実装によっては `change` より先に `compositionend` が
  // 発火するため、確定後の値を確実に親へ伝えるために onCompositionEnd でも
  // onChange を呼ぶ。
  const handleCompositionEnd = (e: CompositionEvent<HTMLInputElement>) => {
    onChange((e.target as HTMLInputElement).value);
  };

  return (
    <div className="u-col u-w100 u-gap16">
      <TitleBlock
        title="エンドクライアント"
        description="このプロジェクトの成果物が、最終的に別の発注元（エンドクライアント）へ納品される場合は、その情報を登録できます。目的物や求められる品質基準の認識を、関係者間で揃えるのに役立ちます。"
      />
      <GuideImage name="project_endclient" />
      <Input
        type="text"
        label="エンドクライアント"
        option="optional"
        placeholder=""
        width="100%"
        maxlength={255}
        name="end_client"
        value={value}
        onChange={handleChange}
        onCompositionEnd={handleCompositionEnd}
      />
    </div>
  );
};

export default ProjectEndClientInput;
